<div class="row">
  <div class="col-12 col-md-8">
    <div class="card">
      <div class="card-body">
        <div class="row mb-2 d-none">
          <div class="col-12 col-md-3">Time Entry Format</div>
          <div class="col-12 col-md-9">
            <select class="form-select form-select-sm" [(ngModel)]="settingsForm.timeEntryFormat">
              <option value="startend">Start and End Time</option>
              <option value="startduration">Start Time and Duration</option>
            </select>
          </div>
        </div>
        <div class="row mb-2">
          <div class="col-12 col-md-3">Time Entries Billable?</div>
          <div class="col-12 col-md-9">
            <select class="form-select form-select-sm" [(ngModel)]="settingsForm.timeBillable">
              <option value="1">Yes</option>
              <option value="0">No</option>
            </select>
          </div>
        </div>
        <div class="row mb-2">
          <div class="col-12 col-md-3">New Tasks Active?</div>
          <div class="col-12 col-md-9">
            <select class="form-select form-select-sm" [(ngModel)]="settingsForm.tasksActive">
              <option value="1">Yes</option>
              <option value="0">No</option>
            </select>
          </div>
        </div>
        <div class="row mb-2">
          <div class="col-12 col-md-3">Meeting Length (Minutes)</div>
          <div class="col-12 col-md-9">
            <input type="text" class="form-control form-control-sm" [(ngModel)]="settingsForm.meetingLength" />
          </div>
        </div>
        <div class="row mb-2">
          <div class="col-12 col-md-3">Time Entry Age (Days)</div>
          <div class="col-12 col-md-9">
            <select class="form-select form-select-sm" [(ngModel)]="settingsForm.timeEntryAge">
              <option value="7">7</option>
              <option value="14">14</option>
              <option value="30">30</option>
              <option value="60">60</option>
            </select>
          </div>
        </div>
        <div class="row mb-2">
          <div class="col-12 col-md-3">Task Used in Last (Days)</div>
          <div class="col-12 col-md-9">
            <select class="form-select form-select-sm" [(ngModel)]="settingsForm.taskListAge">
              <option value="">- All -</option>
              <option value="15">15</option>
              <option value="30">30</option>
              <option value="60">60</option>
              <option value="90">90</option>
            </select>
          </div>
        </div>
        <div class="row">
          <!-- <div class="col-12 text-center">
            <button class="btn btn-sm btn-dark me-2" (click)="saveUserSettings()">
              <i class="fas fa-fw fa-save me-2"></i>Save Settings
            </button>
            <button class="btn btn-sm btn-light" title="Reset Settings">
              <i class="fas fa-fw fa-arrow-rotate-left"></i>
            </button>
          </div> -->
        </div>
      </div>
    </div>
  </div>
  <div class="col-12 col-md-4"></div>
</div>
